export default __webpack_public_path__ + "static/media/search-add-template-plus.1494f68d.svg";